import React, {FC} from 'react';
import {StyleProp} from 'react-native';

import Address, {IAddressProps} from '@/components/Address';
import Avatar from '@/components/Avatar/Avatar';
import Space from '@/components/Space/Space';
import Text from '@/components/Text/Text';
import {useThemedStyles} from '@/theme';
import {ImageSize} from '@/types/media';
import {IBaseUser} from '@/types/user';
import {getSpecialAddress} from '@/utils/ethereum';
import {getUserAddress, getUserAvatar, getUserName} from '@/utils/user';

import {AVATAR_SIZE, styles} from './ProfileInfo.style';

interface IProps {
  user: IBaseUser;
  style?: StyleProp<any>;
  addressProps?: Partial<IAddressProps>;
}

const ProfileInfo: FC<IProps> = ({
  user,
  style: extendedStyle,
  addressProps,
}) => {
  const style = useThemedStyles(styles);
  const address = getUserAddress(user);
  const predefinedName = getSpecialAddress(address)?.name;
  const displayName = predefinedName || getUserName(user);

  return (
    <Space style={[style.container, extendedStyle]}>
      <Avatar
        expandable
        id={user.id}
        url={getUserAvatar(user)}
        size={AVATAR_SIZE}
        resizeWidth={ImageSize.thumbnail}
      />
      <Space ml="s" />
      <Space style={style.content}>
        {displayName ? (
          <Text size="l" weight="semibold" numberOfLines={1}>
            {displayName}
          </Text>
        ) : (
          <Text size="m" weight="semibold" id="address" />
        )}
        <Space mb="xxs" />
        <Address address={address} displayInfo="address" {...addressProps} />
      </Space>
    </Space>
  );
};

export default ProfileInfo;
